/**
 * Polyfills the `fontFamily` property on CSSStyleDeclaration.
 *
 * Workaround for html-to-image npm package bug: https://github.com/bubkoo/html-to-image/issues/508
 * TODO: Remove this polyfill once the upstream bug is fixed. Or Firefox is less annoying. noqa: MISSING_TODO_LINK
 */
function polyfillCSSStyleDeclarationFontFamily() {
  if (
    typeof CSSStyleDeclaration !== "undefined" &&
    !Object.getOwnPropertyDescriptor(
      CSSStyleDeclaration.prototype,
      "fontFamily"
    )
  ) {
    Object.defineProperty(CSSStyleDeclaration.prototype, "fontFamily", {
      get: function () {
        return this.getPropertyValue("font-family");
      },
      set: function (value: string) {
        this.setProperty("font-family", value);
      },
      enumerable: true,
      configurable: true
    });
  }
}

export { polyfillCSSStyleDeclarationFontFamily };
